import { CircleCheck, Users, BellRing, ChefHat, Receipt, CreditCard, CalendarClock, SprayCan } from 'lucide-react';
import { TABLE_STATE_COLORS } from '@/theme/statusColors';

const C = TABLE_STATE_COLORS;
export const STATE_META = {
  free: { label: 'Libre', color: C.free.bg, icon: CircleCheck },
  occupied: { label: 'Ocupada', color: C.occupied.bg, icon: Users },
  waiter_call: { label: 'Llamó al mozo', color: C.waiter_call.bg, icon: BellRing, blink: true },
  order_ready: { label: 'Pedido listo', color: C.order_ready.bg, icon: ChefHat },
  bill_requested: { label: 'Pidió la cuenta', color: C.bill_requested.bg, icon: Receipt },
  paying: { label: 'Pagando', color: C.paying.bg, icon: CreditCard },
  reserved: { label: 'Reservada', color: C.reserved.border, icon: CalendarClock, outline: true },
  to_clean: { label: 'Por limpiar', color: C.to_clean.bg, icon: SprayCan, striped: true },
};

export const STATE_ORDER = ['free', 'occupied', 'waiter_call', 'order_ready', 'bill_requested', 'paying', 'reserved', 'to_clean'];

export const urgencyRank = (s) => ({ waiter_call: 0, order_ready: 1, bill_requested: 2 }[s] ?? 3);

export const stateStyle = (state) => {
  const c = C[state] || C.free;
  if (c.border) return { background: c.bg, color: c.fg, border: `2px dashed ${c.border}` };
  if (c.bg2) return { background: `repeating-linear-gradient(135deg,${c.bg} 0 10px,${c.bg2} 10px 20px)`, color: c.fg };
  return { background: c.bg, color: c.fg };
};

export const elapsed = (iso, now = Date.now()) => {
  if (!iso) return '';
  const mins = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 60000));
  if (mins >= 1440) return `${Math.floor(mins / 1440)} d ${Math.floor((mins % 1440) / 60)} h`;
  return `${Math.floor(mins / 60)}:${String(mins % 60).padStart(2, '0')} h`;
};

export const money = (n) => `$ ${Number(n || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 })}`;

// Fusiona mesas unidas: oculta las secundarias y la principal muestra el grupo
export const fuseGroups = (units) => units.filter(u => !u.group_primary_unit_id || u.group_primary_unit_id === u.unit_id);

export const displayName = (u) => (u.group_names?.length ? u.group_names.join(' + ') : u.name);

export const phones = (n) => `${n} ${n === 1 ? 'celular' : 'celulares'}`;
export const people = (n) => `${n || 1} ${(n || 1) === 1 ? 'persona' : 'personas'}`;

// Ícono del estado: solo visible en alto contraste, para distinguir sin depender del color
export const StateIcon = ({ state }) => {
  const Icon = (STATE_META[state] || STATE_META.free).icon;
  return <Icon className="hc-only w-3 h-3 mr-0.5 shrink-0" aria-hidden="true" />;
};
